import {
  BanknoteX,
  BookX,
  Briefcase,
  Building2,
  Calendar,
  Car,
  CheckSquare,
  ClipboardList,
  Contact,
  DollarSign,
  FileText,
  Folder,
  Globe,
  Handshake,
  Home,
  Link,
  ListTodo,
  Mail,
  MessageSquareText,
  Phone,
  Printer,
  Scale,
  ShieldX,
  Signature,
  Stethoscope,
  Tag,
  Target,
  TrafficCone,
  Umbrella,
  UserIcon,
  Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

import type { Contact as ContactEntity } from "@/lib/types";

// Pages
export const ContactIcon = Contact;
export const MatterIcon = Briefcase;
export const OpportunityIcon = Target;
export const ReferralIcon = Handshake;

/** Icon for contact hero / compact cards — matches ContactsTable list rows. */
export function getContactHeroTypeIcon(
  type: ContactEntity["type"] | undefined,
): LucideIcon {
  if (type === "organization" || type === "group") {
    return Building2;
  }
  return UserIcon;
}

// Contact
export const ContactAddressIcon = Home;
export const ContactPhoneIcon = Phone;
export const ContactFaxIcon = Printer;
export const ContactEmailIcon = Mail;
export const ContactWebsiteIcon = Globe;
export const ContactTextIcon = MessageSquareText;
export const ContactRelationshipIcon = Users;

// Matter
export const TagIcon = Tag;
export const ExpenseIcon = DollarSign;
export const FileIcon = Folder;
export const IncidentIcon = TrafficCone;
export const InsuranceIcon = Umbrella;
export const LienIcon = BookX;
export const LostWageIcon = BanknoteX;
export const MedicalTreatmentAppointmentIcon = Calendar;
export const MedicalTreatmentBillIcon = DollarSign;
export const MedicalTreatmentIcon = Stethoscope;
export const MedicalTreatmentRecordIcon = ClipboardList;
export const MedicalTreatmentPlanIcon = ListTodo;
export const NoteIcon = FileText;
export const PropertyDamageIcon = ShieldX;
export const SettlementIcon = Handshake;
export const TaskIcon = CheckSquare;
export const VehicleIcon = Car;
export const FileReferenceIcon = Link;
export const FileSignatureRequestIcon = Signature;
export const TrustCheckIcon = DollarSign;
export const LitigationIcon = Scale;
export const MatterEmailIcon = Mail;
export const MatterOverviewIcon = Home;

export const getIconForMatterSubItemType = (type: string) => {
  switch (type) {
    case "Medical Treatment":
      return MedicalTreatmentIcon;
    case "Medical Treatment Bill":
      return MedicalTreatmentBillIcon;
    case "Medical Treatment Appointment":
      return MedicalTreatmentAppointmentIcon;
    case "Medical Treatment Record":
      return MedicalTreatmentRecordIcon;
    case "Settlement Negotiation":
      return SettlementIcon;
    case "Cost":
      return ExpenseIcon;
    case "Lost Wage":
      return LostWageIcon;
    case "Lien":
      return LienIcon;
    case "Property Damage":
      return PropertyDamageIcon;
    case "Vehicle":
      return VehicleIcon;
    case "Insurance":
      return InsuranceIcon;
    case "Signature Request":
      return FileSignatureRequestIcon;
    case "Trust Check":
      return TrustCheckIcon;
    case "Incident Report":
      return IncidentIcon;
    default:
      return MatterIcon;
  }
};
